import React from 'react';

import { Navigate, Route, Routes } from 'react-router-dom';

import { CsvValidatedStep, ResolveIssuesStep, UploadCsvStep } from './Steps';

import { CustomFundLineupProvider } from '../../contexts/CustomFundLineupContext';

export const CustomFundLineupFlow: React.FC = () => {
  return (
    <CustomFundLineupProvider>
      <Routes>
        <Route index={true} element={<Navigate to="new" replace={true} />} />
        <Route path="new" element={<UploadCsvStep />} />
        <Route path="edit" element={<ResolveIssuesStep />} />
        <Route path="validated" element={<CsvValidatedStep />} />
      </Routes>
    </CustomFundLineupProvider>
  );
};
